module.exports = __webpack_public_path__ + "static/media/epic-loans-logo-dark-bkg.a4964e1a.svg";